const translations = {
  "en": {
    "Content": "Content"
  },
  "zh-tw": {
    "Content": "目錄"
  }
};

export default translations;
